<template>
    <div class="match-dashboard">
        <div class="match-dashboard__top-row">
            <div class="match-dashboard__col match-dashboard__col--table">
                <TournamentTable />
            </div>
            <div class="match-dashboard__col match-dashboard__col--chart">
                <GpsDataChart />
            </div>
        </div>

        <div class="match-dashboard__middle-row">
            <div class="match-dashboard__col match-dashboard__col--upcoming">
                <UpcomingMatches />
            </div>
            <div class="match-dashboard__col match-dashboard__col--rating">
                <GpsRating />
            </div>
        </div>

        <div class="match-dashboard__bottom-row">
            <MatchesTable />
        </div>
    </div>
</template>

<script>
import { ref, provide } from 'vue'
import TournamentTable from './components/TournamentTable.vue'
import GpsDataChart from './components/GpsDataChart.vue'
import UpcomingMatches from './components/UpcomingMatches.vue'
import GpsRating from './components/GpsRating.vue'
import MatchesTable from './components/MatchesTable.vue'

export default {
    name: 'MatchesDashboard',

    components: {
        TournamentTable,
        GpsDataChart,
        UpcomingMatches,
        GpsRating,
        MatchesTable
    },

    setup() {
        const proLihaAge = ref('U17')
        provide('proLihaAge', proLihaAge)
        return { proLihaAge }
    }
}
</script>

<style scoped>
.match-dashboard {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-height: 100vh;
    background: #141414;
}

.match-dashboard__top-row {
    display: flex;
    gap: 16px;
    height: 380px;
}

.match-dashboard__middle-row {
    display: flex;
    gap: 16px;
    height: 280px;
}

.match-dashboard__col {
    min-width: 0;
}

.match-dashboard__col--table {
    flex: 1.1;
}

.match-dashboard__col--chart {
    flex: 1;
}

.match-dashboard__col--upcoming {
    flex: 1.2;
}

.match-dashboard__col--rating {
    flex: 0.8;
}

.match-dashboard__bottom-row {
    width: 100%;
    margin-top: 4px;
}

@media (max-width: 1200px) {
    .match-dashboard__top-row,
    .match-dashboard__middle-row {
        flex-direction: column;
        height: auto;
    }

    .match-dashboard__col {
        height: 360px;
    }
}
</style>
